import { affiliatePortal } from './affiliatePortal'
import { dashboard } from './dashboard'
import { ideas } from './ideas'
import { integration } from './integration'
import { marketplace } from './marketplace'
import { mobileAppCustomiser } from './mobileAppCustomiser'
import { partners } from './partners'
import { prospecting } from './prospecting'
import { reselling } from './reselling'
import { saas } from './saas'
import { settings } from './settings'
import { snapshots } from './snapshots'
import { subAccounts } from './subAccounts'
import { templateLibraryAdmin } from './templateLibraryAdmin'
import { university } from './university'
import { ghlSwag } from './ghlSwag'
import { aiEmployeePromo } from './aiEmployeePromo'
import { aiAgentsContest } from './aiAgentsContest'

export const agencyRoutes = [
  ...affiliatePortal,
  ...dashboard,
  ...ideas,
  ...integration,
  ...marketplace,
  ...mobileAppCustomiser,
  ...partners,
  ...prospecting,
  ...reselling,
  ...saas,
  ...settings,
  ...snapshots,
  ...subAccounts,
  ...templateLibraryAdmin,
  ...university,
  ...ghlSwag,
  ...aiEmployeePromo,
  ...aiAgentsContest,
]
